import React, { useState } from 'react';
import './style.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { login } from '@/redux/sessionSlice';
import { buildRoutes } from '@/service/buildRoutes';
import api from '../../../data/api';
import Loader from '../../../component/LoderComponent';
import { useAuthService } from '../../../hook/useAuthService';
import { Helmet } from 'react-helmet-async';
import Logo from '@/Asset/images/logo-blaxk.webp';
import KeyboardBackspaceOutlinedIcon from '@mui/icons-material/KeyboardBackspaceOutlined';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

export default function NewLogin() {
	const { loggedInUser } = useAuthService();
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const [formData, setFormData] = useState({
		email: '',
		password: '',
		emailError: '',
		passwordError: '',
		errorMessage: '',
		isLoading: false
	});

	const handleLogoClick = () => navigate(buildRoutes.toMainHome());
	const redirectToSignUp = () => navigate(buildRoutes.toSignUp());
	const redirectToForgotPassword = () => navigate(buildRoutes.toForgotPassword());

	const handleChange = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
			[`${e.target.name}Error`]: '',
			errorMessage: ''
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const { email, password } = formData;
		setFormData({ ...formData, isLoading: true });

		if (!email || !password) {
			setFormData({
				...formData,
				emailError: email ? '' : 'Please fill in your email',
				passwordError: password ? '' : 'Please Enter your password',
				isLoading: false
			});
			return;
		}
		try {
			const response = await api.loginApi(email, password);
			dispatch(login(response?.data));
			await loggedInUser(response?.data);
		} catch (error) {
			setFormData({
				...formData,
				errorMessage: error.response?.data?.message || 'Login failed'
			});
		} finally {
			setFormData(prev => ({ ...prev, isLoading: false }));
		}
	};

	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const togglePasswordVisibility = () => setIsPasswordVisible(!isPasswordVisible);

	const { email, password, emailError, passwordError, errorMessage, isLoading } = formData;

	return (
		<>
			<Helmet>
				<title>Login | The Godfrey Method App</title>
				<meta name="description" content="Login page of The Godfrey Method - On Demand" />
			</Helmet>

			<div className="login-container">
				<div className="onboarding-create-profile__brand-row">
					<button
						type="button"
						className="onboarding-create-profile__back-btn"
						onClick={handleLogoClick}
					>
						<KeyboardBackspaceOutlinedIcon />
					</button>
					<img src={Logo} alt="The Godfrey Method On Demand" className="onboarding-create-profile__logo" />
				</div>
				<div className="login-box">
					<h1 className="login-title">SIGN IN</h1>
					<p className="login-subtitle">Welcome back!<br/>Sign in below to access your account.</p>
					<form onSubmit={handleSubmit} className="login-form">
						<div className="login-form-group">
							<label className="login-label">EMAIL</label>
							<div className="login-input-with-icon">
								<EmailOutlinedIcon className="login-input-icon" />
								<input
									type="email"
									name="email"
									className="login-input login-input--with-icon"
									value={email}
									onChange={handleChange}
									placeholder="jane@example.com"
								/>
							</div>
							{emailError && <span className="login-error">{emailError}</span>}
						</div>
						<div className="login-form-group">
							<label className="login-label">PASSWORD</label>
							<div className="login-password-wrap">
								<input
									type={isPasswordVisible ? 'text' : 'password'}
									name="password"
									className="login-input"
									value={password}
									onChange={handleChange}
									placeholder="••••••••••"
								/>
								<button
									type="button"
									className="login-password-toggle"
									onClick={togglePasswordVisibility}
								>
									{isPasswordVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
								</button>
							</div>
							{passwordError && <span className="login-error">{passwordError}</span>}
						</div>
						{errorMessage && <div className="login-error-message">{errorMessage}</div>}
						<button type="submit" className="login-button" disabled={isLoading}>
							SIGN IN
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none">
								<path d="M4 10h12m0 0l-4-4m4 4l-4 4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
							</svg>
						</button>
						<div className="login-links">
							<p>Don't have an account yet? <span onClick={redirectToSignUp}>Create Your Account</span></p>
							<p>Forgot your password? <span onClick={redirectToForgotPassword}>Reset Your Password</span></p>
						</div>
					</form>
				</div>
			</div>
			{isLoading && <Loader loading />}
		</>
	);
}